/**
 * Feature Flags
 * 
 * Control feature visibility using environment variables.
 * - Production: Features default to false (hidden)
 * - Local dev: Set VITE_FEATURE_*=true in .env.local to enable
 */

export const featureFlags = {
  magicEditor: import.meta.env.VITE_FEATURE_MAGIC_EDITOR === 'true',
  importFromZillow: import.meta.env.VITE_FEATURE_IMPORT_ZILLOW === 'true',
  analytics: import.meta.env.VITE_FEATURE_ANALYTICS === 'true',
};

export function isFeatureEnabled(feature: keyof typeof featureFlags): boolean {
  return featureFlags[feature];
}

